import { Box, Flex } from '@scale/scaleui-radix';
import * as React from 'react';
import { DocsPagination } from '@components/DocsPagination';
import { allThemesRoutes, themesRoutes } from '@utils/themesRoutes';
import { DocsNav } from './DocsNav';
import { DocsPageWrapper } from './DocsPageWrapper';
import { EditPageLink } from './EditPageLink';
import { MobileMenuProvider } from './MobileMenu';
import { SideNav } from './SideNav';
import { ThemesHeader } from './ThemesHeader';
import { ThemesMobileMenu } from './ThemesMobileMenu';

export function ThemesDocsPage({ children }: { children: React.ReactNode }) {
  return (
    <MobileMenuProvider>
      <ThemesHeader />
      <ThemesMobileMenu />
      <Flex>
        <SideNav>
          <DocsNav routes={themesRoutes} />
        </SideNav>
        <DocsPageWrapper>
          <Box>{children}</Box>
          <DocsPagination allRoutes={allThemesRoutes} />
          <EditPageLink />
        </DocsPageWrapper>
      </Flex>
    </MobileMenuProvider>
  );
}
